import { render } from "./AccessModal.vue?vue&type=template&id=353d677f"
import script from "./AccessModal.vue?vue&type=script&lang=js"
export * from "./AccessModal.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__